<template>
  <path pid="0" d="M23.42 7.19L18 11.06V8a3 3 0 00-3-3H4a3 3 0 00-3 3v10a3 3 0 003 3h11a3 3 0 003-3v-3.06l5.42 3.87A1 1 0 0025 18V8a1 1 0 00-1.58-.81zM16 18a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1h11a1 1 0 011 1zm7-1.94L18.72 13 23 9.94z"/>
</template>
